import { useLingui } from "@lingui/react/macro";
import { Button, Radio } from "@offstreetparking/design-system/forms";
import { Text } from "@offstreetparking/design-system/typography";
import { useState } from "react";
import { FlowModal as Modal } from "../../overlays/FlowModal/FlowModal";
import { FlowModalTitle as ModalTitle } from "../../overlays/FlowModal/FlowModalTitle";
import { findDifferences } from "./findDifferences";
type EmailValidationModalProps = {
	suggested?: string;
	original?: string;
	onContinue: (email: string) => void;
	onClose: () => void;
};
export const EmailValidationModal = ({ suggested, original, onContinue, onClose }: EmailValidationModalProps) => {
	const { t } = useLingui();
	const [selectedEmail, setSelectedEmail] = useState(suggested ?? "");
	return (
		<Modal
			i18n={{
				closeButton: t`Cancel`,
				cancelButton: t`Cancel`,
			}}
			isOpen={Boolean(suggested && original)}
			onClose={onClose}
			actions={
				<>
					<Button
						intent="primary"
						onClick={() => {
							onContinue(selectedEmail);
						}}
					>
						{t`Next`}
					</Button>
					<Button type="button" intent="secondary" onClick={onClose}>
						{t`Cancel`}
					</Button>
				</>
			}
		>
			<ModalTitle>{t`Are you sure?`}</ModalTitle>

			<Text>{t`Please review our suggestion below, and choose which version you'd like to use.`}</Text>

			<div className="mt-4">
				<Radio
					name="emailSelection"
					itemClassName="border border-neutral-faded p-4 rounded-md my-2"
					value={selectedEmail}
					onChange={setSelectedEmail}
					options={[
						{
							label: original!,
							value: original!,
							content: (
								<span>
									{original?.split("").map((char, idx) => {
										const diffs = findDifferences(original ?? "", suggested ?? "");
										const isRemoved = diffs.some(
											(diff) => diff.type === "removed" && idx >= diff.start && idx < diff.end,
										);
										return (
											<span
												// biome-ignore lint/suspicious/noArrayIndexKey: static index
												key={idx}
												className={isRemoved ? "bg-critical-faded font-bold" : undefined}
											>
												{char}
											</span>
										);
									})}
								</span>
							),
						},
						{
							label: suggested!,
							value: suggested!,
							content: (
								<span>
									{suggested?.split("").map((char, idx) => {
										const diffs = findDifferences(original ?? "", suggested ?? "");
										const isAdded = diffs.some(
											(diff) => diff.type === "added" && idx >= diff.start && idx < diff.end,
										);
										return (
											<span
												// biome-ignore lint/suspicious/noArrayIndexKey: static index
												key={idx}
												className={isAdded ? "bg-success-faded font-bold" : undefined}
											>
												{char}
											</span>
										);
									})}
								</span>
							),
						},
					]}
				/>
			</div>
		</Modal>
	);
};
